export default __webpack_public_path__ + "static/kr1-f769e648a26cdd4b3f9d6e855b506cdc.webp";